import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IChecklistCompleted } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ChecklistCompletedService extends BaseService<IChecklistCompleted> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'checklistCompleted');
  }

  postProcess(): (data: any) => any {
    return data => {
      this.fixDate(data, 'date');
      return data;
    };
  }
}

export { IChecklistCompleted } from '../shared/api';
